import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "text-center text-lg"
};
const _hoisted_2 = {
  class: "text-xs flex-center"
};
const _hoisted_3 = {
  key: 0,
  class: "mr-0.5"
};
const _hoisted_4 = {
  key: 0,
  class: "w-3 h-3 bg-inherit rotate-45 self-center absolute bottom-0 left-1/2 -translate-x-1/2 -mb-1.5"
};
import MatchModal from "@/modules/match/components/MatchModal.vue";
import TeamLogo from "@/modules/team/components/TeamLogo.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarMatch',
  props: {
    match: null,
    edge: {
      type: Boolean
    },
    location: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "font-bold flex-center flex-col rounded relative cursor-pointer",
        onClick: _cache[0] || (_cache[0] = () => _ctx.$refs.matchModal.show())
      }, [_createVNode(TeamLogo, {
        team: __props.match.oppTeam,
        class: "h-6 w-6 mb-1"
      }, null, 8, ["team"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [__props.location ? (_openBlock(), _createElementBlock("div", _hoisted_3, "(" + _toDisplayString(__props.match.homeTeam.user ? _ctx.$t('home_short') : _ctx.$t('away_short')) + ")", 1)) : _createCommentVNode("", true), _createElementVNode("div", null, _toDisplayString((__props.match.homeTeam.user ? __props.match.awayTeam : __props.match.homeTeam).shortName), 1)]), __props.match.result ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["leading-none", {
          'text-red-600': __props.match.isUserLose,
          'text-green-600': __props.match.isUserWin
        }])
      }, _toDisplayString(__props.match.homeGoals) + ":" + _toDisplayString(__props.match.awayGoals), 3)) : _createCommentVNode("", true)]), _createVNode(MatchModal, {
        ref: "matchModal",
        match: __props.match
      }, null, 8, ["match"]), __props.edge ? (_openBlock(), _createElementBlock("div", _hoisted_4)) : _createCommentVNode("", true)]);
    };
  }
});